interface ActionConfig {
  key: string;
  icon?: string;
  text?: string;
  variant?: string;
  click?: () => void;
}

export default class Action {
  public readonly key: string;
  public readonly icon: string = "";
  public readonly text: string = "";
  public readonly variant: string = "default";
  public readonly click = () => {};

  public constructor(params: ActionConfig) {
    this.key = params.key;
    if (params.icon) this.icon = params.icon;
    if (params.text) this.text = params.text;
    if (params.variant) this.variant = params.variant;
    if (params.click) this.click = params.click;
  }
}
